const React = require('react');
const SentryWrapper = require('./src/components/SentryWrapper');
const Cookies = require('./src/helpers/cookies');

exports.onClientEntry = () => {
  // --- Google Tag Manager ---
  let dataLayerContent = {
    user_id: 'anonymous',
    type: 'non-registered',
    gtm_version: 2,
  };

  if (typeof window['dataLayer'] === 'undefined') {
    window['dataLayer'] = [dataLayerContent];
  } else {
    window['dataLayer'].push(dataLayerContent);
  }

  // --- Snowplow ---
  var snowplowOptions = {
    appId: 'resource-center',
    contexts: {
      webPage: true,
      performanceTiming: true,
    },
    discoverRootDomain: true,
    forceSecureTracker: true,
    platform: 'web',
    post: true,
    postPath: '/spevent',
  };

  window.snowplow(
    'newTracker',
    'co',
    process.env.SNOWPLOW_ENDPOINT,
    snowplowOptions
  );
  window.snowplow('enableActivityTracking', 10, 10); // Ping every 10 seconds after 10 seconds
  var unsafeUserId = Cookies.getCookie('unsafe_user_id');
  var userData = {};

  if (unsafeUserId) {
    window.snowplow('setUserId', unsafeUserId);
    userData = {
      userId: unsafeUserId,
    };
  }

  var userContext = {
    schema: 'iglu:com.datacamp/user/jsonschema/1-0-0',
    data: userData,
  };

  window.snowplow('trackPageView', null, [userContext]);
  window.snowplow('enableLinkClickTracking', null, null, false, [userContext]);

  window.snowplow('enableFormTracking');
  // --- Snowplow ---
};

exports.wrapRootElement = SentryWrapper;
